import { useTranslation } from 'react-i18next'

import { Feedback } from '@features/feedback'

import Accordion from '@shared/ui/accordion'
import Alert from '@shared/ui/alert'
import Breadcrumbs from '@shared/ui/breadcrumbs'
import Container from '@shared/ui/container'
import Wrapper from '@shared/ui/wrapper'

import BonusControl from './bonus-control'

import styles from './styles.module.scss'


export default function LoyaltyProgramPage () {
  const { t: ti } = useTranslation('info')
  const { t: tn } = useTranslation('navigation')
    

  return (
    <div className={styles.page}>
      <Container>
        <Wrapper className={styles.root}>
          <Breadcrumbs
            className={styles.root__breadcrumbs}
            links={[
              {
                title: tn('loyalty'),
              },
            ]}
          />

          <div className={styles.container}>
            <div className={styles.content}>
              <h1>{ti('loyaltyProgram.title')}</h1>
              <p>{ti('loyaltyProgram.description')}</p>

              <h3>{ti('loyaltyProgram.features')}</h3>

              <div className={styles.accrual}>
                <h3>
                  <img src="/icons/plus.svg" alt="" />
                  {ti('loyaltyProgram.accrual.title')}
                </h3>
                <p>{ti('loyaltyProgram.accrual.description')}</p>
              </div>
            </div>

            <div className={styles['bonuses-list']}>
              {Array.from({
                length: 3,
              }).map((_, index) => {
                return (
                  <div className={styles['bonuses-list__item']}>
                    <h3>
                      <img src={`/icons/bonuses/${index + 1}.svg`} alt="" />
                      {ti(`bonuses.${index + 1}.title`)}
                    </h3>
                    <p>{ti(`bonuses.${index + 1}.desc`)}</p>
                  </div>
                )
              })}
            </div>

            <Alert
              className={styles.root__alert}
              dangerouslySetInnerHTML={{
                __html: ti('loyaltyProgram.restrictions'),
              }}
            />

            <div className={styles.root__block}>
              <h3>{ti('howToGetBonusCard.title')}</h3>

              <div className={styles['bonus-card']}>
                <div className={styles['bonus-card__wrapper']}>
                  <div className={styles['bonus-card__list']}>
                    {Array.from({
                      length: 3,
                    }).map((_, index) => {
                      return (
                        <div className={styles['bonus-card__item']} key={index}>
                          <img
                            src={`/img/bonus-card/${index + 1}.svg`}
                            alt=""
                          />

                          <div className={styles['bonus-card__text']}>
                            <h4>
                              {ti(`howToGetBonusCard.list.${index + 1}.title`)}
                            </h4>
                            <p>
                              {ti(`howToGetBonusCard.list.${index + 1}.desc`)}
                            </p>
                          </div>
                        </div>
                      )
                    })}
                  </div>

                  <img
                    className={styles['bonus-card__img']}
                    src="/img/card.png"
                    alt=""
                  />
                </div>
              </div>
            </div>

            <Alert
              className={styles.root__alert}
              dangerouslySetInnerHTML={{
                __html: ti('loyaltyProgram.importantNote'),
              }}
            />

            <div className={styles.root__block}>
              <h3>{ti('loyaltyProgram.manage')}</h3>
              <BonusControl />
            </div>

            <h2>{ti('loyaltyProgram.aboutProgram')}</h2>

            <div className={styles.faq}>
              <div className={styles.faq__item}>
                <Accordion
                  triggerClassName={styles.faq__trigger}
                  trigger={
                    <div className={styles.faq__title}>
                      {ti('loyalty.about.title')}
                    </div>
                  }
                  content={
                    <div className={styles.faq__desc}>
                      {ti('loyalty.about.desc')}
                    </div>
                  }
                />
              </div>
              <div className={styles.faq__item}>
                <Accordion
                  triggerClassName={styles.faq__trigger}
                  trigger={
                    <div className={styles.faq__title}>
                      {ti('loyalty.where.title')}
                    </div>
                  }
                  content={
                    <div className={styles.faq__desc}>
                      {ti('loyalty.where.desc')}
                    </div>
                  }
                />
              </div>
              <div className={styles.faq__item}>
                <Accordion
                  triggerClassName={styles.faq__trigger}
                  trigger={
                    <div className={styles.faq__title}>
                      {ti('loyalty.bonus.title')}
                    </div>
                  }
                  content={
                    <div className={styles.faq__desc}>
                      <p>{ti('loyalty.bonus.desc')}</p>
                      <Alert className={styles.faq__note}>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ti('loyalty.bonus.note'),
                          }}
                        ></span>
                        <br />
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ti('loyalty.bonus.important'),
                          }}
                        ></span>
                      </Alert>
                      <p>{ti('loyalty.bonus.replace')}</p>
                      <p>{ti('loyalty.bonus.more')} </p>
                      <p>
                        {ti('loyalty.bonus.email')}{' '}
                        <a href="mailto:info@anvar.kz">
                          info@anvar.kz
                        </a>
                      </p>
                    </div>
                  }
                />
              </div>
            </div>

            <Feedback className={styles.root__feedback} />
          </div>
        </Wrapper>
      </Container>
    </div>
  )
}